import {
  CalendarIcon,
  DiffIcon,
  InfoIcon,
  PeopleIcon,
  ShareAndroidIcon
} from "@primer/octicons-react";
import {
  Box,
  Label,
  Text
} from "@primer/react";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Table } from "@primer/react/lib-esm/DataTable";
import styled from "styled-components";
import { hocSinhApi } from "../../../../api/hocSinhApi";
import UserAvatar from "../../../../components/user-avatar";
import { IHocSinhSelectRequest } from "../../../../models/request/hocsinh/IHocSinhSelectRequest";
import { IHocSinhTongHopAceItemResponse } from "../../../../models/response/hocsinh/IHocSinhTongHopAceItemResponse";
import { RootState } from "../../../../state/reducers";
interface IHocSinhGroup {
  key: string;
  students: IHocSinhTongHopAceItemResponse[];
}
type CanBoNhanVienProps = {
  ts_hocsinh_id: number,
}
const StyledContainer = styled(Box)`
    padding: 12px;
  `;

const StyledTable = styled(Table)`
    width: 100%;
    border-collapse: collapse;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    border-radius: 6px;
    display: flex;
    flex-direction: column;
  `;

const StudentCard = styled.div`
    flex: 1;
    min-width: 300px;
    padding: 20px;
    border: 1px solid #d0d7de;
    border-radius: 8px;
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 16px;
    cursor: pointer;
    transition: all 0.2s ease;
  
    &:hover {
      border-color: #0366d6;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      transform: translateY(-2px);
    }
  `;
const CanBoNhanVien = (props: CanBoNhanVienProps) => {
  const { nam_hoc, dm_coso_id } = useSelector((x: RootState) => x.common);
  const [allHocSinhs, setAllHocSinhs] = useState<any[]>([]);
  const loadAllHocSinh = useCallback(async () => {
    const res = await hocSinhApi.SelectTongHopCbnv(props.ts_hocsinh_id, nam_hoc);
    if (res.is_success) {
      setAllHocSinhs(res.data);
    }
  }, [nam_hoc, dm_coso_id]);
  useEffect(() => {
    loadAllHocSinh();
  }, []);

  return (
    <>
      {allHocSinhs.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh", // Giữ nội dung căn giữa nhưng có thể mở rộng nếu cần
            textAlign: "center"
          }}
        >
          <img
            src="https://true-north-school.s3.cloudfly.vn/fee/datagrid_empty"
            alt="Không có dữ liệu"
            style={{ width: "60px", height: "60px", marginBottom: "5px" }}
          />
          <Box sx={{ fontSize: "13px", fontWeight: "400", color: "#8C8C8C" }}>
            Chưa có dữ liệu con em cán bộ nhân viên
          </Box>
        </Box>


      ) : (
        <StyledContainer>
          <StyledTable>
            <Box sx={{
              height: 'calc(100vh - 350px)',
              overflowY: 'auto',
            }}>
              <Table.Body>
                <Table.Row>
                  <Table.Cell style={{ padding: '5px' }} colSpan={6}>
                    <Box sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 3,
                      padding: '12px'
                    }}>
                      {allHocSinhs.map((student) => (
                        <StudentCard
                          key={student.id}
                        >
                          <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            mb: 0
                          }}>
                            <UserAvatar fullName={student.ten_nhan_vien} size="large" />
                            <Box sx={{ flex: 1 }}>
                              <Text sx={{ fontWeight: 600, color: '#0969da', fontSize: 2 }}>
                                {student.ten_nhan_vien}
                              </Text>
                            </Box>
                          </Box>
                          <Box sx={{
                            background: '#f6f8fa',
                            p: 2,
                            mt: 0,
                            borderRadius: '6px',
                            fontSize: '13px'
                          }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Box sx={{ color: '#0969da' }}><ShareAndroidIcon size={14} /></Box>
                              Mã nhân viên: <Text sx={{ fontWeight: 600 }}>{student.ma_nhan_vien}</Text>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
                              <Box sx={{ color: '#0969da' }}><InfoIcon size={14} /></Box>
                              Cấp quản lý: <Text sx={{ fontWeight: 600 }}>{student.capquanly_cbnv}</Text>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
                              <Box sx={{ color: '#0969da' }}><PeopleIcon size={14} /></Box>
                              Quan hệ của học sinh: <Text sx={{ fontWeight: 600 }}>{student.quanhe_cbnv}</Text>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
                              <Box sx={{ color: '#0969da' }}><DiffIcon size={14} /></Box>
                              Miễn giảm: <Text sx={{ fontWeight: 600 }}>{student.hinh_thuc_mien_giam}</Text>
                            </Box>
                          </Box>
                        </StudentCard>
                      ))}
                    </Box>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>  </Box>

          </StyledTable>
        </StyledContainer>
      )}
    </>
  )
};

export default CanBoNhanVien;